// extracted by mini-css-extract-plugin
module.exports = {"mobileSectionBorder":"styles_mobileSectionBorder__1JMCs","hr":"styles_hr__2PVoa","hr-red":"styles_hr-red__4mjYR","hr-red-container":"styles_hr-red-container__2d9Bn"};